module.exports = __webpack_public_path__ + "static/media/floor3_zone_v3.25028deb.png";